import React from 'react'
import { RouteProps } from 'react-router-dom'

import CancelTemplate from '../../../../templates/Cancel'

import { useCancelSlotProps } from './useProps'

const CancelSlot: React.FC<RouteProps> = () => {
  const templateProps = useCancelSlotProps()

  return <CancelTemplate {...templateProps} />
}

export default CancelSlot
